import { TQcoActions } from './qco.actions';
import { LINE_SETUP_TICKET_DEFAULT_PAGINATION_OPTION, TQcoActionTypes, TQcoState } from './qco.models';

export const initialState: TQcoState = {
  lineSetupTicketsListing: null,
  lineSetupSubtasksListing: null,
  lineSetupTicketNewSetupDetails: null,
  lineSetupTicketCurrentSetupDetails: null,
  lineSetupTicketPaginationOption: LINE_SETUP_TICKET_DEFAULT_PAGINATION_OPTION,
};

export function qcoReducer(state = initialState, action: TQcoActions): TQcoState {
  switch (action.type) {
    case TQcoActionTypes.GetLineSetupTicketsListingSuccess:
      return {
        ...state,
        lineSetupTicketsListing: action.payload,
      };

    case TQcoActionTypes.GetLineSetupTicketsSubtasksSuccess:
      return {
        ...state,
        lineSetupSubtasksListing: action.payload,
      };

    case TQcoActionTypes.FetchLineSetupTicketCurrentSetupSuccess:
      return {
        ...state,
        lineSetupTicketCurrentSetupDetails: action.payload,
      };

    case TQcoActionTypes.FetchLineSetupTicketNewSetupSuccess:
      return {
        ...state,
        lineSetupTicketNewSetupDetails: action.payload,
      };

    case TQcoActionTypes.SetLineSetupTicketPaginationOption:
      return {
        ...state,
        lineSetupTicketPaginationOption: action.payload,
      };

    default:
      return state;
  }
}
